__turbopack_context__.v({
  "dialog": "UIBlock-module__JgalbG__dialog",
  "dialogContent": "UIBlock-module__JgalbG__dialogContent",
  "spinnerContainer": "UIBlock-module__JgalbG__spinnerContainer",
});
